// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zru2gc{padding-inline:var(--ds-space-100,8px)}\n._1rjcv77o{padding-block:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
